import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';
import { List } from '@material-ui/core';
import { Navigation } from './components';

const useStyles = makeStyles(theme => ({
  root: {
    height: '100%',
    backgroundColor: theme.palette.white
  },
  toolbar: {
    padding: theme.spacing(2, 0),
    textAlign: 'center'
  },
  addIcon: {
    marginRight: theme.spacing(1)
  },
  addButton: {
    maxWidth: 231
  },
  button: {
    justifyContent: 'flex-start',
    textTransform: 'none',
    letterSpacing: 0,
    fontWeight: theme.typography.fontWeightRegular
  },
  folderIcon: {
    marginRight: theme.spacing(1),
    color: theme.palette.icon
  },
  totalItems: {
    marginLeft: theme.spacing(1)
  },
  newItems: {
    marginLeft: 'auto'
  },
  active: {
    fontWeight: theme.typography.fontWeightMedium,
    color: theme.palette.primary.main,
    '& $folderIcon': {
      color: theme.palette.primary.main
    }
  }
}));

const Folders = props => {
  const { className, folders, checked, onFolderOpen, open, ...rest } = props;

  const classes = useStyles();

  const handleSelect = (parent) => (dataset) => {
    onFolderOpen && onFolderOpen(dataset, parent);
  };

  return (
    <div
      {...rest}
      className={clsx(classes.root, className)}
    >
      <List>
        <Navigation
          open={open}
          checked={checked}
          component="div"
          handleSelect={handleSelect}
          pages={folders}
        />
      </List>
    </div>
  );
};

Folders.propTypes = {
  checked: PropTypes.array,
  className: PropTypes.string,
  folders: PropTypes.array,
  onFolderOpen: PropTypes.func,
  open: PropTypes.bool
};

export default Folders;
